import React from 'react';
import { PriceBreakdownWrapper } from './PriceBreakdownWrapper';

interface RestaurantsBreakdownProps {
  priceItems: any[];
  currency: string;
  eurPrices?: any[];
}

export function RestaurantsBreakdown({ priceItems, currency, eurPrices }: RestaurantsBreakdownProps) {
  const RESTAURANT_ITEMS = [
    { id: 1, name: 'Repas, Restaurant bon marché' },
    { id: 2, name: 'Repas pour 2, Restaurant moyen, 3 plats' },
    { id: 3, name: 'Menu McDonalds (ou équivalent)' }
  ];

  const getItemPrice = (itemId: number) => {
    const item = priceItems.find(item => item.item_id === itemId);
    const eurItem = eurPrices?.find(item => item.item_id === itemId);
    
    if (!item) return null;

    return {
      price: item.average_price,
      eurPrice: eurItem?.average_price
    };
  };

  return (
    <PriceBreakdownWrapper title="Prix moyens constatés pour vous aider à estimer votre budget">
      <div className="space-y-2">
        {RESTAURANT_ITEMS.map(item => {
          const prices = getItemPrice(item.id);
          if (!prices) return null;

          return (
            <div key={item.id} className="flex flex-col sm:flex-row sm:items-center sm:justify-between py-2 border-b border-gray-200/50 dark:border-gray-700/50 last:border-0">
              <span className="text-sm text-gray-600 dark:text-gray-400 mb-1 sm:mb-0">
                {item.name}
              </span>
              <div className="text-right font-mono text-base sm:text-sm font-medium text-primary-600 dark:text-primary-400">
                {(prices.eurPrice || prices.price).toFixed(2)} €
              </div>
            </div>
          );
        })}
      </div>
    </PriceBreakdownWrapper>
  );
}